var exports = {
  "KP": "codeBlobWrapper__v-bhvc",
  "BK": "codeBlobInner__L_BQg_",
  "UB": "codeBlobInnerBlame__1vPz44",
  "U": "cursorContainer__GBFg75",
};

module.exports = exports;
